import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import {
  Button,
  Counter,
  Input,
  KeyValue,
  Label,
  Loading,
  SubHeading,
  Switch,
} from "../../../shared/Components";
import { useEscapeKey } from "../../../shared/Hooks";
import { getAxios, postAxios, putAxios } from "../../../shared/Services/commonService";
import {
  API_COMMON_FANCY,
  API_FANCY_LATEST,
  API_FANCY_RATE,
  API_FANCY_VOLUME,
  API_UPDATE_MARKET,
} from "../../../utils/api/ApiConstant";
import { useQuery } from "@tanstack/react-query";
import {
  CommonModal,
  EndGameModal,
  FancyConfigureModal,
  FancySettingModal,
} from "../../../shared/Components/Modal";
import useSocketContext from "../../../shared/context/socketContext";
import { useSelector } from "react-redux";
import { validateNumber } from "../../../shared/helper/common";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import showToast from "../../../utils/toastUtil";

const FancyView = () => {
  const inputRef = useRef(null);
  const { user } = useSelector((state) => state.user);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [rowData, setRowData] = useState(location.state?.rowOriginalData || {});
  const [rate, setRate] = useState();
  const [action, setAction] = useState("");
  const [middleInput, setMiddleInput] = useState({
    no: { rate: "", diff: "" },
    yes: { rate: "", diff: "" },
  });
  const [firstInput, setFirstInput] = useState({
    no: { rate: "", diff: "" },
    yes: { rate: "", diff: "" },
  });
  const [lastInput, setLastInput] = useState({
    no: { rate: "", diff: "" },
    yes: { rate: "", diff: "" },
  });
  const [counter, setCounter] = useState(0);
  const [allowBetChecked, setAllowBetChecked] = useState(null);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });
  const { _socket } = useSocketContext();
  const [ballStartFlag, setBallStartFlag] = useState(null);

  const { data: fancyLatestData } = useQuery({
    queryKey: ["fancyLatestData"],
    queryFn: async () => await getAxios(`${API_FANCY_LATEST}/${id}`, {}),
  });

  const { data: fancyViewData } = useQuery({
    queryKey: ["fancyViewData"],
    queryFn: async () => await getAxios(`${API_COMMON_FANCY}/${id}`, {}),
  });

  const { isLoading: volumeLoad, data: fancyVolumeData } = useQuery({
    queryKey: ["fancyVolumeData"],
    queryFn: async () => await getAxios(API_FANCY_VOLUME, {}),
  });

  // uses for if default state not exist then redirect to fancy page
  useEffect(() => {
    if (!location.state?.rowOriginalData) navigate("/eventmaster/fancy");
  }, []);

  useEffect(() => {
    if (
      fancyVolumeData &&
      fancyLatestData?.rateTime !== null &&
      fancyLatestData?.rateTime !== undefined &&
      fancyLatestData?.rateTime !== ""
    ) {
      // setCounter(fancyLatestData?.rateTime || 0);
      const master_code_id = fancyLatestData?.master_code_id;
      setRate(master_code_id);

      // check rate time and fancy volume api data must be valid
      // on load time if rate time is grater than 0 then all process should be work earlier
      if (fancyLatestData?.rateTime > 0) {
        const tempVal = master_code_id;
        const numericValue = tempVal.replace(/[^0-9.]/g, "");

        // uses for end characters after + or -
        let firstChar = "";
        let lastChar = "";
        const plusIndex = master_code_id.indexOf("+");
        const minusIndex = master_code_id.indexOf("-");
        if (plusIndex !== -1)
          firstChar =
            master_code_id.substring(plusIndex + 1).split(/[-+]/)[0] || "";

        if (minusIndex !== -1)
          lastChar =
            master_code_id.substring(minusIndex + 1).split(/[-+]/)[0] || "";

        handleActionClick("Live", false, numericValue, { firstChar, lastChar });
      } else {
        handleActionClick("ball start", false);
      }
    }
  }, [fancyLatestData?.rateTime, fancyVolumeData]);

  useEffect(() => {
    if (
      fancyViewData &&
      fancyViewData?.fancyMode &&
      fancyViewData?.fancyMode.toLowerCase() !== "auto"
    ) {
      setRowData(fancyViewData);
      setAllowBetChecked(fancyViewData?.allowBat);
    }
  }, [fancyViewData]);

  const handleEvent = useCallback((data) => {
    const { rates } = data;

    setMiddleInput({
      no: {
        rate: rates?.["0"]?.rate_1 || "",
        diff: rates?.["0"]?.value_1 || "",
      },
      yes: {
        rate: rates?.["0"]?.rate_2 || "",
        diff: rates?.["0"]?.value_2 || "",
      },
    });
  }, []);

  const handleApiObjEvent = useCallback((data) => {
    // console.log("🚀 ~ handleApiObjEvent ~ data:", data);
  }, []);

  useEffect(() => {
    if (!_socket) return;

    _socket.connect();

    _socket.emit("join-room", "room1");
    _socket.emit("join-room", id);
    _socket.on("fancy-auto-rate", handleEvent);
    _socket.on("api-obj", handleApiObjEvent);

    return () => {
      _socket.emit("leave-room", id);
    };
  }, [_socket]);

  const endCharacter = useMemo(() => {
    if (!rate) return { first: "", last: "" };

    let first = "";
    let last = "";

    const plusIndex = rate.indexOf("+");
    const minusIndex = rate.indexOf("-");

    if (plusIndex !== -1) {
      first = rate.substring(plusIndex + 1).split(/[-+]/)[0] || "";
    }

    if (minusIndex !== -1) {
      last = rate.substring(minusIndex + 1).split(/[-+]/)[0] || "";
    }

    return { first, last };
  }, [rate]);

  const showRate = useMemo(() => {
    if (!rate) return null;
    const tempVal = rate;
    const numericValue = tempVal.replace(/[^0-9.]/g, ""); // Allow only numbers and dot
    return numericValue ?? null;
  }, [rate]);

  const handleBallStartandSuspend = useCallback(
    ({ emitData = {} }) => {
      setCounter(0);
      setMiddleInput({
        no: { rate: "", diff: "" },
        yes: { rate: "", diff: "" },
      });
      setFirstInput({
        no: { rate: "", diff: "" },
        yes: { rate: "", diff: "" },
      });
      setLastInput({
        no: { rate: "", diff: "" },
        yes: { rate: "", diff: "" },
      });
      _socket.emit(
        "change-status",
        Object.keys(emitData).length !== 0
          ? emitData
          : {
              fancy_id: id,
              status: "ballstart",
              type: "fancy",
            }
      );
    },
    [rate]
  );

  const handleActionClick = (
    val,
    isFetch = true,
    custRate = null,
    initEndCharacter
  ) => {
    switch (val) {
      case "live":
        if (custRate || showRate) {
          setCounter(rowData?.fancyConfigurationSetting?.ballStart || 0);
          handleCustomData({ action: "live", isFetch });
        } else {
          setCounter(0);
        }
        break;

      case "Live":
        if (custRate || showRate) {
          setCounter(fancyLatestData?.rateTime || 0);
          handleCustomData({
            action: "live",
            isFetch,
            custPriceVal: custRate,
            initEndCharacter,
          });
        }
        break;

      case "ball start":
        handleBallStartandSuspend({
          emitData: {},
        });
        handleCustomData({ action: "", isFetch, isEmitApiObj: false });
        break;

      case "suspend":
        handleBallStartandSuspend({
          emitData: {
            fancy_id: id,
            status: "suspend",
            type: "fancy",
          },
        });
        handleCustomData({ action: "", isFetch, isEmitApiObj: false });
        break;

      default:
        console.warn(`Unhandled action: ${val}`);
        break;
    }

    setAction(val);
  };
  useEscapeKey(handleActionClick);

  const handleInputChange = (e, key) => {
    const { name, value } = e.target;
    setMiddleInput((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [name]: value,
      },
    }));
  };

  const handleCustomData = ({
    action,
    isFetch,
    custPriceVal = null,
    isEmitApiObj = true,
    initEndCharacter,
  }) => {
    // initial load var
    let custPrice = custPriceVal ?? showRate;

    // matched volumn by
    let customEndCharacterObj = {
      firstInputmatch: initEndCharacter?.firstChar || endCharacter?.first,
      lastInputmatch: initEndCharacter?.lastChar || endCharacter?.last,
    };
    let customMatches;
    if (customEndCharacterObj?.firstInputmatch && fancyVolumeData) {
      customMatches = {
        ...customMatches,
        first: fancyVolumeData.find(
          (item) =>
            item.key.toLowerCase() ===
            customEndCharacterObj?.firstInputmatch.toLowerCase()
        ),
      };
    }
    if (customEndCharacterObj?.lastInputmatch && fancyVolumeData) {
      customMatches = {
        ...customMatches,
        last: fancyVolumeData.find(
          (item) =>
            item.key.toLowerCase() ===
            customEndCharacterObj?.lastInputmatch.toLowerCase()
        ),
      };
    }

    let custFirstInput = {
      no: {
        rate: "",
        diff: "",
      },
      yes: {
        rate: "",
        diff: "",
      },
    };
    let custMiddInput = {
      no: {
        rate: "",
        diff: "",
      },
      yes: {
        rate: "",
        diff: "",
      },
    };
    let custLastInput = {
      no: {
        rate: "",
        diff: "",
      },
      yes: {
        rate: "",
        diff: "",
      },
    };

    if ((action && action === "live") || action === "Live") {
      if (!customMatches?.first && !customMatches?.last) {
        custMiddInput = {
          no: {
            rate: custPrice,
            diff: 100,
          },
          yes: {
            rate:
              Number(custPrice) +
              rowData?.fancyConfigurationSetting?.rateDiffrence,
            diff: 100,
          },
        };
      } else {
        // set missle input
        custMiddInput = {
          no: {
            rate: validateNumber(custPrice),
            diff: 100,
          },
          yes: {
            rate: validateNumber(custPrice) + 1,
            diff: 100,
          },
        };

        // set first input
        if (customMatches?.first)
          custFirstInput = {
            no: {
              rate: validateNumber(custPrice) + 1,
              diff: customMatches?.first?.value1 || 100,
            },
            yes: {
              rate: validateNumber(custPrice) + 1,
              diff: customMatches?.first?.value2 || 100,
            },
          };

        // set last input
        if (customMatches?.last)
          custLastInput = {
            no: {
              rate: validateNumber(custPrice) + 1,
              diff: customMatches?.last?.value1 || 100,
            },
            yes: {
              rate: validateNumber(custPrice) + 1,
              diff: customMatches?.last?.value2 || 100,
            },
          };
      }

      // handle counter using flag state
      setBallStartFlag((prev) => !prev);
    }

    setFirstInput(custFirstInput);
    setMiddleInput(custMiddInput);
    setLastInput(custLastInput);

    // handle counter using flag state
    // setBallStartFlag((prev) => !prev);

    // handle request
    const payload = {
      master_code_id: rate,
      id,
      fancyId: id,
      no1: custFirstInput?.no?.rate,
      no1Vol: custFirstInput?.no?.diff,
      no2: custMiddInput?.no?.rate,
      no2Vol: custMiddInput?.no?.diff,
      no3: custLastInput?.no?.rate,
      no3Vol: custLastInput?.no?.diff,
      yes1: custFirstInput?.yes?.rate,
      yes1Vol: custFirstInput?.yes?.diff,
      yes2: custMiddInput?.yes?.rate,
      yes2Vol: custMiddInput?.yes?.diff,
      yes3: custLastInput?.yes?.rate,
      yes3Vol: custLastInput?.yes?.diff,
      limit: "",
      statusValue: [
        {
          id: "MS960523",
          name: "active",
          value: "ACTIVE",
        },
      ],
      userId: user.user_id,
      userName: user.username,
    };

    if (isEmitApiObj)
      _socket.emit("api-obj", { data: payload, id, type: "fancy" });

    if (isFetch)
      handlePostRequest({
        url: API_FANCY_RATE,
        payload,
        modalRequest: false,
      });
  };

  const handlePutRequest = useCallback(
    async ({ url, payload, modalRequest = false, updateRowData = false }) => {
      const res = await putAxios(url, payload);

      if (res && updateRowData) setRowData(res);
      if (modalRequest && res) {
        setIsShow((prev) => ({
          ...prev,
          isOpen: false,
          rowData: {},
          name: "",
        }));
      }
    },
    []
  );

  const handlePostRequest = useCallback(
    async ({ url, payload, modalRequest = false }) => {
      const res = await postAxios(url, payload);

      if (modalRequest && res) {
        setIsShow((prev) => ({
          ...prev,
          isOpen: false,
          rowData: {},
          name: "",
        }));
      }
    },
    []
  );

  const handleKeyDown = (e) => {
    // const regex = /^\d+([+-][a-zA-Z])?$/;
    // const isValidString = regex.test(name);
    const isValidString = true;

    if (e.key === "Enter") {
      if (isValidString) {
        handleActionClick("live");
      } else {
        inputRef.current?.focus(); // Focus on the input if it's not disabled
        inputRef.current?.select();
        showToast.error("Invalid string");
      }
    }
  };

  return (
    <>
      <SubHeading subTitle={rowData?.fancyName} isAddBtn={false} />
      <div className="card-body">
        <div className="row">
          <div className="col-lg-6 col-12 m-0 p-1">
            <div className="row m-0 p-0">
              <div className="col-md-12 m-0 p-1">
                <div className="setting_but_box">
                  <div className="allow_bet_btn">
                    <Label htmlFor="allowBat">Allow bet</Label>
                    <div className="form-switch form-switch-sm">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="allowBat"
                        checked={allowBetChecked}
                        onChange={(e) => {
                          e.target.blur();
                          setAllowBetChecked(!allowBetChecked);
                          handlePutRequest({
                            url: `${API_UPDATE_MARKET}/${rowData?._id}`,
                            payload: {
                              ...rowData,
                              allowBat: !allowBetChecked,
                            },
                            modalRequest: true,
                          });
                        }}
                        value={allowBetChecked}
                        onFocus={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <Button
                    className="btn_main "
                    onClick={() =>
                      setIsShow((prev) => ({
                        ...prev,
                        isOpen: true,
                        rowData: rowData,
                        modalTitle: "End game",
                        modalContent: EndGameModal,
                      }))
                    }
                  >
                    End game
                  </Button>
                  <Button
                    className="btn_main "
                    onClick={() =>
                      setIsShow((prev) => ({
                        ...prev,
                        isOpen: true,
                        rowData: rowData,
                        modalTitle: "Fancy Configure",
                        modalContent: FancyConfigureModal,
                      }))
                    }
                  >
                    Fancy Configure
                  </Button>
                  <Button
                    className="btn_main "
                    onClick={() =>
                      setIsShow((prev) => ({
                        ...prev,
                        isOpen: true,
                        rowData: rowData,
                        modalTitle: "Fancy Setting",
                        modalContent: FancySettingModal,
                      }))
                    }
                  >
                    Fancy Setting
                  </Button>
                </div>
              </div>

              <div className="col-12 m-0 p-0">
                <div
                  className=" cursor-point card m-0 mb-1 p-2 pb-1 d-flex justify-content-between  flex-row"
                  onClick={() => setIsVisible(!isVisible)}
                >
                  <h6 className="p-0 m-0 font-weight-bold  ">Fancy Rate</h6>
                  <MdOutlineKeyboardArrowDown fontSize={23} />
                </div>
                <div
                  className={`card p-0 m-0 mb-1 ${
                    isVisible ? "d-block" : "d-none"
                  }`}
                >
                  <div className="row m-0 p-1 ">
                    {volumeLoad ? (
                      <Loading />
                    ) : (
                      fancyVolumeData &&
                      fancyVolumeData.map((x, i) => (
                        <Fragment key={i}>
                          <KeyValue obj={x} />
                        </Fragment>
                      ))
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-12 m-0 p-0 pb-1">
                <div className="card m-0 p-0 ">
                  <div className="row m-0 p-0  ">
                    <div className="col-lg-12 m-0 p-1">
                      <ul className="market_box">
                        <li className="market market_bg-a">No</li>
                        <li className="market market_bg-b">Yes</li>
                      </ul>
                    </div>

                    <div className="col-lg-12 m-0 p-0 px-1 ">
                      <Input
                        type="text"
                        className="form-control  form-select-lg"
                        value={action}
                        disabled={true}
                      />
                    </div>
                    <div className="col-lg-12 m-0 p-0">
                      <div className="row m-0 p-0">
                        <div className="col-lg-6 m-0 p-1">
                          <div className="enter_market_box">
                            <Input
                              type="text"
                              className="form-control market_bg-a market_card  "
                              placeholder=""
                              value={firstInput.no.rate}
                              disabled={true}
                            />
                            <Input
                              type="text"
                              className="form-control market_bg-a market_card "
                              placeholder=""
                              value={firstInput.no.diff}
                              disabled={true}
                            />
                          </div>
                          <div className="enter_market_box">
                            <Input
                              type="text"
                              className="form-control market_bg-a market_card  "
                              placeholder=""
                              value={middleInput.no.rate}
                              name="rate"
                              onChange={(e) => handleInputChange(e, "no")}
                              disabled={true}
                            />
                            <Input
                              type="text"
                              className="form-control market_bg-a market_card  "
                              placeholder=""
                              value={middleInput.no.diff}
                              name="diff"
                              onChange={(e) => handleInputChange(e, "no")}
                              disabled={true}
                            />
                          </div>
                          <div className="enter_market_box">
                            <Input
                              type="text"
                              className="form-control market_bg-a market_card  "
                              placeholder=""
                              value={lastInput.no.rate}
                              disabled={true}
                            />
                            <Input
                              type="text"
                              className="form-control  market_bg-a market_card  "
                              placeholder=""
                              value={lastInput.no.diff}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 m-0 p-1">
                          <div className="enter_market_box">
                            <Input
                              type="text"
                              className="form-control market_bg-b market_card "
                              placeholder=""
                              value={firstInput.yes.rate}
                              disabled={true}
                            />
                            <Input
                              type="text"
                              className="form-control market_bg-b market_card "
                              placeholder=""
                              value={firstInput.yes.diff}
                              disabled={true}
                            />
                          </div>
                          <div className="enter_market_box">
                            <Input
                              type="text"
                              className="form-control market_bg-b market_card "
                              placeholder=""
                              value={middleInput.yes.rate}
                              name="rate"
                              onChange={(e) => handleInputChange(e, "yes")}
                            />
                            <Input
                              type="text"
                              className="form-control market_bg-b market_card "
                              placeholder=""
                              value={middleInput.yes.diff}
                              name="diff"
                              onChange={(e) => handleInputChange(e, "yes")}
                            />
                          </div>
                          <div className="enter_market_box">
                            <Input
                              type="text"
                              className="form-control market_bg-b market_card "
                              placeholder=""
                              value={lastInput.yes.rate}
                              disabled={true}
                            />
                            <Input
                              type="text"
                              className="form-control market_bg-b market_card "
                              placeholder=""
                              value={lastInput.yes.diff}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12  m-0 p-0 pb-1">
                <div className="card ">
                  <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-1">
                      <p className="m-0 p-0 py-1 ">
                        Action counter: &nbsp;
                        <Counter
                          initialValue={counter}
                          countFinish={handleActionClick}
                          ballRestart={ballStartFlag}
                        />
                      </p>
                    </div>
                    <div className="col-12 m-0 p-1 mb-1">
                      <Input
                        type="text"
                        className="form-control  form-select-lg text-center"
                        placeholder="Enter rate"
                        ref={inputRef}
                        onFocus={() => inputRef.current?.select()}
                        onChange={(e) => setRate(e.target.value)}
                        value={rate}
                        onKeyDown={handleKeyDown}
                        disabled={
                          fancyViewData && fancyViewData?.fancyMode
                            ? fancyViewData?.fancyMode.toLowerCase() === "auto"
                            : false
                        }
                      />
                    </div>
                    <div className="col-lg-6 m-0 p-1">
                      <Button
                        className="badge btn-success "
                        onClick={() => handleActionClick("live")}
                      >
                        Live
                      </Button>
                    </div>
                    <div className="col-lg-6 m-0 p-1">
                      <Button
                        className="btn_main "
                        onClick={() => handleActionClick("ball start")}
                      >
                        Ball Start
                      </Button>
                    </div>
                    <div className="col-lg-12 m-0 p-1">
                      <Button
                        className="btn_main"
                        onClick={() => handleActionClick("suspend")}
                      >
                        Suspend
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12 m-0 p-1">
            <div className="row m-0 p-0">
              <div className="col-lg-5 col-12 m-0 p-0 pe-1 pb-1">
                <div className="card p-0 m-0">
                  <h6 className="m-0 p-2">Run Chart</h6>
                  <div className="respo-scroll table_book">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="text-left">Run</th>
                          <th className="text-left">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* <tr className="matched-runner-bg-color-detail1">
                          <td className="text-left">demo</td>
                          <td className="text-right">17</td>
                        </tr>
                        <tr className="matched-runner-bg-color-detail2">
                          <td className="text-left">demo</td>
                          <td className="text-right">500</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-12 m-0 p-0 pe-1 pb-1">
                <div className="card p-0 m-0">
                  <h6 className="m-0 p-2">Matched bet</h6>
                  <div className="respo-scroll table_book">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="text-left">User Name</th>
                          <th className="text-left">Runner</th>
                          <th className="text-right "> Run</th>
                          <th className="text-right "> Stake</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* <tr className="matched-runner-bg-color-detail1">
                          <td className="text-left">demo</td>
                          <td className="text-left">
                            <span>
                              do not bet / 1000
                              <span className="bet-list-span">
                                24/05/25:37:14px
                              </span>
                            </span>
                          </td>
                          <td className="text-right">17</td>
                          <td className="text-right">500</td>
                        </tr>
                        <tr className="matched-runner-bg-color-detail2">
                          <td className="text-left">demo</td>
                          <td className="text-left">
                            <span>
                              do not bet / 1000
                              <span className="bet-list-span">
                                24/05/25:37:14px
                              </span>
                            </span>
                          </td>
                          <td className="text-right">17</td>
                          <td className="text-right">500</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleShowHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
              handlePutRequest,
              handlePostRequest,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default FancyView;
